import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";
import amber from "@mui/material/colors/amber";
import blue from "@mui/material/colors/blue";
import green from "@mui/material/colors/green";
import red from "@mui/material/colors/red";
import { inject, observer } from "mobx-react";
import React from "react";
import { RootStore } from "../stores/rootStore";

interface IProps {
  store?: RootStore;
  children?: React.ReactNode;
}

const GetColor = (variant: string) => {
  if (variant === "success") {
    return { backgroundColor: green[600] };
  }
  if (variant === "error") {
    return { backgroundColor: red[800] };
  }
  if (variant === "info") {
    return { backgroundColor: blue[700] };
  }
  if (variant === "warning") {
    return { backgroundColor: amber[700] };
  }
};

const SnackProvider: React.FC<IProps> = ({ store, children }) => {
  return (
    <>
      {store!.snackStore.snacks.map(s => (
        <Snackbar
          key={s.messageId}
          anchorOrigin={s}
          open
          sx={{ m: 1 }}
          autoHideDuration={s.autoHideDuration}
          onClose={() => store!.snackStore.remove(s)}
        >
          <SnackbarContent
            sx={GetColor(s.variant)}
            message={<span id="message-id">{s.message}</span>}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={() => store!.snackStore.remove(s)}
              >
                <CloseIcon />
              </IconButton>
            ]}
          />
        </Snackbar>
      ))}
      {children}
    </>
  );
};

export default inject("store")(observer(SnackProvider));
